import React from 'react';

const WorkHeading = ({sub}) => {
  let fontFamily = `"Montserrat Alternates", sans-serif`;
  return <h3 style={{fontFamily: fontFamily}}>Work<span className="sub">{sub}</span></h3>
};

export default WorkHeading;
